import React, { Component } from 'react';
import '../css/App.css';
class Loader extends Component {

    render() {

        return (
            <div className="loading  h-h">
                <div className="loader">
                    <img src={require('../images/kauvery_logo.gif')} alt="loader" style={{width:100}}/>
                </div>
               
            </div>
        );
    }
}

export default Loader;